import Switch from "react-switch";
import React, { Component } from 'react';
import { Modal, Button, Table } from "react-bootstrap";

export default class DepartmentModal extends Component {

    state = {
        defaultRole: -1,
        departments: []
    }

    removeDepartment = (id) => {
        let defaultRole = (this.state.defaultRole === id ? -1 : this.state.defaultRole)
        this.setState({
            departments: this.state.departments.filter(dept => dept.id !== id),
            defaultRole
        })
    }

    addDepartment = (department) => {
        this.setState({
            departments: [...this.state.departments, department]
        })
    }

    initializeModal = () => {
        let alreadyCheckedDepartments = this.props.selectedRoles.find((role) => role.roleId === this.props.currentRole)
        if (alreadyCheckedDepartments.departments) {
            if (this.props.defaultRole.roleId === alreadyCheckedDepartments.roleId) {
                this.setState({
                    departments: [...this.state.departments, ...alreadyCheckedDepartments.departments],
                    defaultRole: this.props.defaultRole.departmentId
                })
            } else {
                this.setState({
                    departments: [...this.state.departments, ...alreadyCheckedDepartments.departments]
                })
            }
        }
    }


    departments = () => {

        return this.props.departments.map((department, index) => {
            let isChecked = this.state.departments.find((dept) => dept.id === department.id)
            return (
                <tr key={index}>
                    <td>
                        <Switch
                            checked={isChecked}
                            onChange={() => {
                                if (isChecked) {
                                    this.removeDepartment(department.id)
                                } else {
                                    this.addDepartment(department)
                                }
                            }}
                        />
                    </td>
                    <td>
                        <Button variant='link' size='lg' onClick={() => this.setState({ defaultRole: department.id })} disabled={!isChecked}>
                            {(this.state.defaultRole === department.id ? <i className="fa fa-check-circle" /> : <i className="fa fa-circle" />)}
                        </Button>
                    </td>
                    <td>{department.Name}</td>
                </tr>
            )
        })
    }

    render() {
        return (
            <Modal
                size='lg'
                centered={true}
                scrollable={true}
                show={this.props.isVisible}
                onEnter={this.initializeModal}
                onHide={this.props.closeModal}
                onExit={() => this.setState({
                    defaultRole: -1,
                    departments: []
                })}>
                <Modal.Header closeButton>
                    <Modal.Title>Select Departments</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Table striped bordered hover style={{}}>
                        <thead>
                            <tr>
                                <th>Select</th>
                                <th>Default Role</th>
                                <th>Department</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.departments()}
                        </tbody>
                    </Table>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary"
                        onClick={() => {
                            this.props.addDepartments(this.props.currentRole, this.state.departments, this.state.defaultRole)
                            this.props.closeModal()
                        }}>
                        Add Departments
                    </Button>
                </Modal.Footer>

            </Modal>
        );
    }
}
